module.exports = __webpack_public_path__ + "img/mw20r.50ece2fd.jpg";